<div class="modal fade" id="kpiManagerModal" tabindex="-1" role="dialog" aria-labelledby="reportsModalLabel">
  <div class="modal-lg modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title">KPI Manager</h4>
      </div>
      <div class="modal-body" *ngIf="kpiManager">
        <sob-kpi-manager [kpiManager]="kpiManager"></sob-kpi-manager>
      </div>
    </div>
  </div>
</div>
